// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewUser_root__3aQ6W"};